import { SVGProps, Ref, forwardRef } from 'react';

export const ClockOutlinedSize12Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={12} height={12} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M1.4 6c0-1.241.312-2.386.995-3.205C3.053 2.005 4.154 1.4 6 1.4s2.947.605 3.605 1.395c.683.819.995 1.964.995 3.205s-.312 2.386-.995 3.205C8.947 9.995 7.846 10.6 6 10.6s-2.947-.605-3.605-1.395C1.712 8.386 1.4 7.241 1.4 6M.5 6C.5 3.25 1.875.5 6 .5s5.5 2.75 5.5 5.5-1.375 5.5-5.5 5.5S.5 8.75.5 6m5.95-.265V2.8h-.9v3.465l2.875 1.597.437-.787z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ClockOutlinedSize12Glyph.displayName = 'ClockOutlinedSize12Glyph';
